export class BidCompany
{
    companyId: number;
    companyName: string;
}
